import {
  STOCK_SELECT_TRANSLATION
} from './constants';

import { cloneDeep, capitalize } from "lodash"

export function selectTranslation(newInconsistence, translation) {
  return (dispatch, getState) => {
    const { stock: { translatorStepKey, translator, schema, stocks, stockToProcess } } = getState()
    var inconsistenciesArray = cloneDeep(translator[translatorStepKey].inconsistencies)
    const translationItem = newInconsistence.values.find((value) => value.id === translation)

    inconsistenciesArray?.forEach(inconsistence => {
      if (inconsistence.index === newInconsistence.index) {
        inconsistence.translation = translationItem.id
      }
    })

    const stockToProcessClone = cloneDeep(stockToProcess)
    const stocksClone = cloneDeep(stocks);
    stockToProcessClone.forEach(stock => {
        if (stock[translatorStepKey] === newInconsistence[translatorStepKey]) {
        const metadataHasSameValue = schema[translatorStepKey].metadata.every(
          metadataKey => {
            return stock[metadataKey] === newInconsistence[metadataKey]
          }
        )
        if (translation) {
          stocksClone[stock.index].error = stocksClone[stock.index].error?.filter(err => !err.includes((schema[translatorStepKey].name).toLowerCase()))
        } else if (metadataHasSameValue) {
          const attributeName = capitalize(schema[translatorStepKey].name)
          const errorMessage = `El atributo ${attributeName} está sin validar.`
          if(stocksClone[stock.index].error){
            !stocksClone[stock.index].error.includes(errorMessage) && stocksClone[stock.index].error.push(errorMessage)
          } else {
            stocksClone[stock.index].error = [errorMessage];
          } 
        } 
      }
    })

    dispatch({
      type: STOCK_SELECT_TRANSLATION,
      data: {
        translatorStepKey,
        inconsistenciesArray,
        stocks: stocksClone,
      }
    })
  }
}

export function reducer(state, action) {
  if (action.type === STOCK_SELECT_TRANSLATION) {
      return {
        ...state,
        stocks: action.data.stocks,
        translator: {
          ...state.translator,
          [action.data.translatorStepKey]: {
            ...state.translator[action.data.translatorStepKey],
            inconsistencies: action.data.inconsistenciesArray
          }
        },
        messageRouteLeaving: 'Estás por salir sin guardar los cambios. ¿Querés salir igual?'
      }
  }
  else{
      return state
  }
}
